export const MAX_SLOTS = 5;
